var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPlace = function SvgIconPlace(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "7mm",
    height: "7mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.84 19.84",
    fill: "#717679",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.99,1.51c-3.75,0-6.81,2.86-6.81,6.37.05,4.72,5.01,8.83,6.82,10.18,1.79-1.32,6.62-5.33,6.67-10.18,0-1.7-.68-3.3-1.91-4.49-1.25-1.21-2.94-1.88-4.76-1.88M9.99.31c4.43,0,7.88,3.4,7.88,7.59-.06,6.66-7.88,11.65-7.88,11.65,0,0-7.95-5.16-8.02-11.65C1.97,3.7,5.56.31,9.99.31Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.92,
    cy: 8.1,
    r: 2.32
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-place.d4ed224cb79d1f8b0f8363beb47a47dc.svg";